import { render, staticRenderFns } from "./automationComponentType.vue?vue&type=template&id=7bd582e6&"
import script from "./automationComponentType.vue?vue&type=script&lang=js&"
export * from "./automationComponentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports